import { GameCard as GameCardComponent } from "./GameCard";
import { GameCardSkeleton } from "./components";

export const GameCard = Object.assign(GameCardComponent, {
  Skeleton: GameCardSkeleton,
});
export { FavouriteBtn } from "./components";
